import { render, staticRenderFns } from "./PointOfServiceServiceForm.vue?vue&type=template&id=0a4b1966&scoped=true&v-if=internal&"
import script from "./PointOfServiceServiceForm.vue?vue&type=script&lang=ts&"
export * from "./PointOfServiceServiceForm.vue?vue&type=script&lang=ts&"
import style0 from "./PointOfServiceServiceForm.vue?vue&type=style&index=0&id=0a4b1966&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b1966",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
